(function() {
  "use strict";

  angular.module("PrintQueueList")

    .constant("PRINT_QUEUE_LIST_FILTERS", [
      {
        name: 'Network',
        parameter: 'networks',
        type: 'pagination',
        service: 'NetworkListService',
        paginationObject: null,
        supportIcon: 'icon-mobile-plain',
        values: []
      },
      {
        name: 'NetworkType',
        parameter: 'networkTypeFilter',
        type: "checkbox",
        values: [{
            key: "OFFICE",
            value: "Company",
            type: "checkbox"
          },
          {
            key: "HOME",
            value: "HomeOffice",
            type: "checkbox"
          }
        ]
      },
      {
        name: "Computers",
        parameter: null,
        type: 'range',
        sharedKey: "wsRange",
        setBreaker: true,
        wsRange: {
          key: 'wsRange',
          value: 'Computers',
          type: 'range',
          keys: [{
              key: "wsCountFrom",
              count: 0
            },
            {
              key: "wsCountTo",
              count: null
            }
          ]
        },
        values: [{
            key: "wsCountFrom",
            value: "From",
            sharedKey: "wsRange",
            initialCount: 0,
            parameter: "wsCountFrom",
            type: "range"
          },
          {
            key: "wsCountTo",
            value: "To",
            sharedKey: "wsRange",
            initialCount: 0,
            parameter: "wsCountTo",
            type: "range"
          }
        ]
      },
      {
        name: "Active",
        parameter: "active",
        type: "radio",
        values: [{
            key: "active",
            value: "Yes",
            state: true,
          },
          {
            key: "active",
            value: "No",
            state: false,
          },
          {
            key: "active",
            value: 'ClearFilter',
            state: null
          }
        ]
      },
      {
        name: "AddAutomatically",
        parameter: "autoInstall",
        type: "radio",
        values: [{
            key: "autoInstall",
            value: "Yes",
            state: true,
          },
          {
            key: "autoInstall",
            value: 'No',
            state: false,
          },
          {
            key: "autoInstall",
            value: 'ClearFilter',
            state: null
          }
        ]
      },
      {
        name: 'RemovePrintQueueAutomatically',
        parameter: 'autoRemove',
        type: 'radio',
        values: [{
            key: 'autoRemove',
            value: 'Yes',
            state: true
          },
          {
            key: 'autoRemove',
            value: 'No',
            state: false
          },
          {
            key: 'autoRemove',
            value: 'ClearFilter',
            state: null
          }
        ]
      },
      {
        name: "ViaTheCloud",
        parameter: "viaCloud",
        type: "radio",
        values: [
          {
            key: "viaCloud",
            value: "ViaTheCloudOnAllNetworks",
            state: 'AllNetworks',
          },
          {
            key: "viaCloud",
            value: "ViaTheCloudOnSelectedNetworksOnly",
            state: 'SelectedNetworks',
          },
          {
            key: "viaCloud",
            value: "No",
            state: 'No',
          },
          {
            key: "viaCloud",
            value: 'ClearFilter',
            state: null
          }
        ]
      },
      {
        name: "ProcessPdf",
        parameter: "alwaysReprint",
        type: "radio",
        values: [{
            key: "alwaysReprint",
            value: "Yes",
            state: true,
          },
          {
            key: "alwaysReprint",
            value: "No",
            state: false,
          },
          {
            key: "alwaysReprint",
            value: 'ClearFilter',
            state: null
          }
        ]
      },
      {
        name: "ExemptFromSecurePrint",
        parameter: "ignoreSecurePrint",
        type: "radio",
        values: [{
            key: "ignoreSecurePrint",
            value: "Yes",
            state: true,
          },
          {
            key: "ignoreSecurePrint",
            value: 'No',
            state: false,
          },
          {
            key: "ignoreSecurePrint",
            value: 'ClearFilter',
            state: null
          }
        ]
      },
      {
        name: "MobilePrint",
        parameter: "mobilePrint",
        type: "radio",
        values: [{
            key: "mobilePrint",
            value: "Yes",
            state: true,
          },
          {
            key: "mobilePrint",
            value: "No",
            state: false,
          },
          {
            key: "mobilePrint",
            value: 'ClearFilter',
            state: null
          }
        ]
      },
      {
        name: "PublishWithMicrosoftUniversalPrint",
        parameter: "publishUp",
        type: "radio",
        values: [{
            key: "publishUp",
            value: "Yes",
            state: true,
          },
          {
            key: "publishUp",
            value: "No",
            state: false,
          },
          {
            key: "publishUp",
            value: 'ClearFilter',
            state: null
          }
        ]
      },
      {
        name: "PrintInDuplexByDefault",
        parameter: "defaultDuplex",
        type: "radio",
        values: [{
            key: "defaultDuplex",
            value: "Yes",
            state: true,
          },
          {
            key: "defaultDuplex",
            value: "No",
            state: false,
            name: "DefaultDuplex"
          },
          {
            key: "defaultDuplex",
            value: 'ClearFilter',
            state: null
          }
        ]
      },
      {
        name: "PrintInBlackByDefault",
        parameter: "defaultMono",
        type: "radio",
        values: [{
            key: "defaultMono",
            value: "Yes",
            state: true,
          },
          {
            key: "defaultMono",
            value: "No",
            state: false,
          },
          {
            key: "defaultMono",
            value: 'ClearFilter',
            state: null
          }
        ]
      }
    ])
    .constant('SORT_PRINT_QUEUE_LIST', {
      NAME: "QUEUE_NAME",

    })

    .controller("PrintQueueListController", [
      "$scope", "$filter", "SUPPORTED_OS", "WorkstationListService", "$location", "URLS",
      "$ngBootbox", "URL_PARAMS", "NetworkListService", "toastr", "WorkstationListPOSTPaging",
      "PRINT_QUEUE_LIST_FILTERS", "SORT_PRINT_QUEUE_LIST", "PrintQueueListPaging", "PrintQueueListService",
      "NetworkListPaging", 'EventHandlerService', '$rootScope', 'currentTenant', '$routeParams', '$timeout',
      '$window',
      function(
        $scope, $filter, SUPPORTED_OS, WorkstationListService, $location, URLS,
        $ngBootbox, URL_PARAMS, NetworkListService, toastr, WorkstationListPOSTPaging,
        PRINT_QUEUE_LIST_FILTERS, SORT_PRINT_QUEUE_LIST, PrintQueueListPaging, PrintQueueListService,
        NetworkListPaging, EventHandlerService, $rootScope, currentTenant, $routeParams, $timeout,
        $window
      ) {

        //Var declaration
        $scope.orderByText = "QUEUE_NAME";
        $scope.reverse = false;
        $scope.showSearchField = false;
        $scope.searchInputFieldHolderFocusKey = "searchInputFieldHolderFocusKey";
        $scope.checkAllCheckboxes = {
          isSelected: false
        };
        $scope.networkListService = NetworkListService;
        $scope.selectedQueues = 0;
        $scope.supportedOs = SUPPORTED_OS;
        $scope.unknownNetwork = {
          info: {
            name: "UnknownNetwork"
          }
        };
        $scope.lastPageReached = false;
        $scope.filtersList = null;
        $scope.workstationListPaging = new WorkstationListPOSTPaging();
        $scope.printQueueListPaging = new PrintQueueListPaging();
        $scope.printQueueListPaging.pagingCriteria.viaCloud = null;
        $scope.filterNetworkListPaging = new NetworkListPaging();
        $scope.workstationContainer = null;
        $scope.requestType = 'POST';
        $scope.queueContainer = null;
        $scope.queueContainerOriginal = null;
        $scope.searchInputPlaceholderText = 'SearchQueueByName';
        $scope.helpCaption = "HelpPrintQueuesPage";
        $scope.eventHandlerService = EventHandlerService;
        $scope.currentTenant = currentTenant;
        var initialListRequest = true;
        $scope.loadingPage = true;
        $scope.noDataMessage = 'NoSearchResultQueue';
        $scope.windowWidth = $window.innerWidth;


        (function(){
          initEventHandler();
        })();



        function initEventHandler() {
          $scope.eventHandlerService.deRegisterListeners();
        };

        $scope.$watch(function() {
          return $rootScope.currentUser
        }, function() {
          if ($rootScope.currentUser) {
            $scope.me = $rootScope.currentUser;
            var queueFilters = angular.copy(PRINT_QUEUE_LIST_FILTERS);
            initFilters(adjustToUserPermissions(queueFilters));
          }
        })

        function adjustToUserPermissions (queueFilters) {
          queueFilters[0].paginationObject = $scope.filterNetworkListPaging;
          if (!$scope.me.permissions.TENANT_ADMIN) {
            $scope.printQueueListPaging.pagingCriteria.networks = $scope.me.networks;
            queueFilters[0].paginationObject.pagingCriteria.sites = $scope.me.sites.map(site => site.id) || [];
            $scope.workstationListPaging.pagingCriteria.networkFilterEnabled = true;
            $scope.workstationListPaging.pagingCriteria.networkFilters = $scope.me.networks;
            $scope.workstationListPaging.pagingCriteria.sites = $scope.me.sites.map(site => site.id) || [];
          }
          $scope.printQueueListPaging.pagingCriteria.page = $routeParams['printQueuePage'] > 1 ? $routeParams['printQueuePage'] - 1 : 0;
          return queueFilters
        }

        function initFilters(queueFilters) {
          WorkstationListService.postGetWorkstationListPaged($scope.workstationListPaging).then(function(workstationContainer) {
            queueFilters[2].values[1].initialCount = workstationContainer.page.totalElements;
            $scope.filtersList = queueFilters;
          }).catch(function(error) {});
        }

        function reportWindowSize() {
          $scope.windowWidth = $window.innerWidth;
          $scope.$apply();
        }
        window.onresize = reportWindowSize;

        $scope.deleteQueue = function(queue) {
          if (queue) {
            $ngBootbox.confirm($filter("stringular")($filter("translate")("DeletePrintQueue"), queue.info.name))
              .then(function() {
                PrintQueueListService.deletePrintQueue(queue).then(function() {
                  toastr.success($filter("stringular")($filter("translate")("DeletePrintQueue"), queue.info.name));
                }).catch(function(error) {});
              })
              .catch(function(error) {});
          } else {
            throw "$scope.deleteQueue: queue is missing";
          }
        };

        $scope.deleteSelectedQueues = function() {
          if ($scope.queueContainer.list.length > 0) {
            var selectedPrintQueues = $scope.queueContainer.list.findAllElements({
              options: {
                isSelected: true
              }
            });
            if (selectedPrintQueues.length > 0) {
              var message = "";
              if (selectedPrintQueues.length < 2) {
                message = $filter("stringular")($filter("translate")("DeletePrintQueue"), selectedPrintQueues[0].info.name);
              } else {
                message = $filter("stringular")($filter("translate")("DeletePrintQueues"), selectedPrintQueues.length);
              }
              $ngBootbox.confirm(message)
                .then(function() {
                  PrintQueueListService.bathcDeletePrintQueues(selectedPrintQueues, 'DELETE', 'PRINT_QUEUES_DELETE_BATCH').then(function() {
                    var message = "";
                    if (selectedPrintQueues.length < 2) {
                      message = $filter("stringular")($filter("translate")("PrintQueueDeleted"), selectedPrintQueues[0].info.name);
                    } else {
                      message = $filter("stringular")($filter("translate")("PrintQueuesDeleted"), selectedPrintQueues.length);
                    }
                    toastr.success(message);
                  }).catch(function(error) {});
                })
                .catch(function(error) {});
            } else {
              toastr.error($filter("translate")("SelectPrintQueueNone") + ", " + $filter("translate")("SelectPrintQueue"));
            }
          } else {
            toastr.error($filter("translate")("SelectPrintQueueNone"));
          }
        };

        $scope.changeOrderByValue = function(textValue) {
          if ($scope.reverse) {
            $scope.reverse = false;
            $scope.printQueueListPaging.pagingCriteria.direction = 'ASC';
          } else {
            $scope.reverse = !$scope.reverse;
            $scope.printQueueListPaging.pagingCriteria.direction = 'DESC';
          }
          $scope.printQueueListPaging.pagingCriteria.sort = SORT_PRINT_QUEUE_LIST[textValue];
          $scope.orderByText = SORT_PRINT_QUEUE_LIST[textValue];
          $scope.getQueueListPaged();
        };

        $scope.orderByNetworkNames = function(workstation) {
          if (workstation) {
            return workstation.customProperties.networkNames;
          } else {
            throw "$scope.orderByNetworkNames: workstation is missing"
          }
        };

        $scope.editSelectedQueues = function() {
          if ($scope.queueContainer.list.length > 0) {
            var selectedItems = $scope.queueContainer.list.findAllElements({
              options: {
                isSelected: true
              }
            });
            if (selectedItems.length > 0 ) {
              var idArray = [];
              angular.forEach(selectedItems, function(printQueueToEdit) {
                var urlReference = printQueueToEdit.info._links.self.href.split('printers/')[1];
                var printerId = urlReference.split('/queues/')[0];
                var queueId = urlReference.split('/queues/')[1];
                var pairedId = `${printerId}:${queueId}`;
                idArray.push(pairedId);
              });

              var url = URLS.PRINT_QUEUE_PROPERTIES_MULTI.replace(URL_PARAMS.PRINT_QUEUE_URL.LOCATION, idArray);
              $location.path(url).search({printQueuePage: parseInt($scope.printQueueListPaging.pagingCriteria.page) + 1 });
            } else {
              throw "$scope.editSelectedUsers: selectedItems or user are missing";
            }
          }
        };

        $scope.selectAllItems = function() {
          angular.forEach($scope.queueContainer.list, function(value) {
            value.options.isSelected = $scope.checkAllCheckboxes.isSelected;
          });
        };

        $scope.getQueueListPaged = function(skipResetScroll) {
          if (!skipResetScroll) {
            angular.element('.px-scrollbar-scroll').scrollTop(0);
          }

          $scope.loadingPage = true;

          if (!$scope.me.permissions.TENANT_ADMIN) {
            if (!$scope.printQueueListPaging.pagingCriteria.networks?.length){
              $scope.printQueueListPaging.pagingCriteria.networks = $scope.me.networks;
            }
          }
          $scope.eventHandlerService.queue.stopQueue();
          PrintQueueListService.getPrintQueueListPaged($scope.printQueueListPaging).then(function(queueContainer) {
            if (initialListRequest || $scope.printQueueListPaging.pagingCriteria.page === 0) {
              initialListRequest = false;
              $location.path($location.path(), false).search({ printQueuePage: parseInt($scope.printQueueListPaging.pagingCriteria.page) + 1 }).replace();
            } else {
              $location.path($location.path(), false).search({ printQueuePage: parseInt($scope.printQueueListPaging.pagingCriteria.page) + 1 })
            }

            checkGroupStatus(queueContainer);

            if ($scope.eventHandlerService.getControllerScope() !== 'printQueueList') {
              $scope.eventHandlerService.setControllerScopeData('printQueueList', $scope.queueContainer.list)
            } else {
              refreshEventHandler();
            }
          }).catch(function(error) {});
        }

        function checkGroupStatus (queueContainer) {
          angular.forEach(queueContainer.list, function(queue) {
            queue = evalGroups(queue)
          })


          $scope.queueContainer = queueContainer;
          $scope.queueContainerOriginal = angular.copy(queueContainer);
          $scope.loadingPage = false;
        }

        function evalGroups (queue) {
          var groups = [];

          if (queue.info._links['px:group']) {
            if (!Array.isArray(queue.info._links['px:group'])) {
              if (!groups.includes(queue.info._links['px:group'].href)) {
                groups.push(queue.info._links['px:group'].href)
              }
            } else {
              for (var i = 0; i < queue.info._links['px:group'].length; i++) {
                if (!groups.includes(queue.info._links['px:group'][i].href)) {
                  groups.push(queue.info._links['px:group'][i].href);
                }
              }
            }
          }

          if (queue.info._links['px:autoInstallGroup']) {
            if (!Array.isArray(queue.info._links['px:autoInstallGroup'])) {

              if (!groups.includes(queue.info._links['px:autoInstallGroup'].href)) {
                groups.push(queue.info._links['px:autoInstallGroup'].href)
              }

            } else {
              for (var i = 0; i < queue.info._links['px:autoInstallGroup'].length; i++) {
                if (!groups.includes(queue.info._links['px:autoInstallGroup'][i].href)) {
                  groups.push(queue.info._links['px:autoInstallGroup'][i].href);
                }
              }
            }
          }

          if (queue.info._links['px:defaultForGroup']) {
            if (!Array.isArray(queue.info._links['px:defaultForGroup'])) {
              if (!groups.includes(queue.info._links['px:defaultForGroup'].href)) {
                groups.push(queue.info._links['px:defaultForGroup'].href)
              }
            } else {
              for (var i = 0; i < queue.info._links['px:defaultForGroup'].length; i++) {
                if (!groups.includes(queue.info._links['px:defaultForGroup'][i].href)) {
                  groups.push(queue.info._links['px:defaultForGroup'][i].href);
                }
              }
            }
          }


          queue.info.numberOfGroups = groups.length;

          return queue;
        }

        $scope.getNextPage = function functionName(showPrevious) {
          if (showPrevious) {
            if ($scope.printQueueListPaging.pagingCriteria.page > 0) {
              $scope.printQueueListPaging.pagingCriteria.page--;
            }
          } else {
            if ($scope.printQueueListPaging.pagingCriteria.page + 1 < $scope.queueContainer.page.totalPages) {
              $scope.printQueueListPaging.pagingCriteria.page++;
            }
          }
          $scope.getQueueListPaged();
        }

        function getPrintQueueByUrl (printQueueId) {
          $scope.eventHandlerService.queue.stopQueue();
          PrintQueueListService.getPrintQueueByURL(printQueueId).then(function(printQueue) {
            for (var i = 0; i < $scope.queueContainer.list.length; i++) {
              if ($scope.queueContainer.list[i].info._links.self.href === printQueue.info._links.self.href) {
                $scope.queueContainer.list[i].info = printQueue.info;
              }
            }
            refreshEventHandler();
          }).catch(function(error) {
            refreshEventHandler();
          });
        }

        function refreshEventHandler() {
          $scope.eventHandlerService.refreshScopeData('printQueueList', $scope.queueContainer.list).then(function(){
            $scope.eventHandlerService.queue.setState('idle');
          }).catch(function(error) {
            refreshEventHandler();
          });
        }

        $scope.$watch(function() {
          return $scope.queueContainer;
        }, function() {
          if ($scope.queueContainer) {
            $scope.selectedQueues = $scope.queueContainer.list.findAllElements({
              options: {
                isSelected: true
              }
            }).length;
            if (!$scope.selectedQueues) {
              $scope.checkAllCheckboxes.isSelected = false;
            } else {
              $scope.checkAllCheckboxes.isSelected = ($scope.selectedQueues === $scope.queueContainer.list.length);
            }
          }
        }, true);


        var PRINT_QUEUE_LIST_listener = $rootScope.$on('printQueueList', function(name, data) {
          switch (data.operation) {
            case 'refreshList':
              $scope.getQueueListPaged(true);
            break;
            case 'replaceItem':
                getPrintQueueByUrl(data.itemId);
            break;
          }
        })

        $scope.$on('$destroy', function() {
          PRINT_QUEUE_LIST_listener();
        });

        ////////////////////////////////////////////
        ////////////////////////////////////////////
        // TOOLTIP STUFF
        ////////////////////////////////////////////
        $scope.showTooltip = function (showTip, position, tooltipScope, context) {
          if (showTip) {
            switch(tooltipScope) {
              case 'site':
                siteTooltip(position, context);
              break;
              case 'queue':
                queueTooltip(position, context);
              break;
              case 'workstationCount':
                workstationCountTooltip(position, context);
              break;
            }
          } else {
            $scope.clearTooltip();
          }
        }

        function siteTooltip (position, title) {

          $scope.clearTooltip();
          $scope.tooltipContent = {
            title: title,
            type: 'statement',
          }

          $scope.tooltipObject = {
            position: {left: position.startX, top: position.startY + 20}
          }
        }

        function workstationCountTooltip(position, queue) {
          $scope.tooltipContent = {
            type: 'workstationCount',
            queue: queue.info
          };
          $scope.tooltipObject = {
            position: {
              left: position.startX,
              top: position.startY + 20
            },
            contextMenu: false
          };
        }

        function queueTooltip (position, queue) {
          $scope.clearTooltip();
          $scope.tooltipContent = {
            title: 'Queue',
            type: 'queueDetails',
            queue: queue.info,
          }
          $scope.tooltipObject = {
            position: {left: position.startX - 15, top: position.startY + 20},
            contextMenu: false
          }
        }

        $scope.clearTooltip = function () {
          $scope.tooltipContent = null;
          $scope.tooltipObject = null;
        }


        ////////////////////////////////////////////
        ////////////////////////////////////////////
        // LIST MENU
        ////////////////////////////////////////////
        $scope.openListMenu = function (event, queue) {
          var position = document.getElementById(event.target.id).getBoundingClientRect();
          setTimeout(function () {
            $scope.closeListMenu();
            $scope.listMenuContext = queue;
            $scope.listMeta = {
              position: {left: position.x, top: position.y},
              parentId: event.target.id,
              type: 'queueList',
              scrollContainerId: 'QueueScrollContainer'
            }
            $scope.$apply();
          }, 50)
        }

        $scope.closeListMenu = function (queue, action) {
          $scope.listMenuContext = null;
          $scope.listMeta = null;

          switch (action) {
            case 'DELETE_QUEUE':
              $scope.deleteQueue(queue);
            break;
          }
        }

      }
    ]);
})();
